import {
  type FilterTableItemDescriptor,
  generateHeadersAndFilters,
} from "../../../../../Components/FilterTable/filterTableUtils";
import { type CloudZeroAssetRowData } from "./CloudZeroAssetRow";

const cloudZeroItemDescriptors: FilterTableItemDescriptor<CloudZeroAssetRowData>[] = [
  {
    headerText: "Organization ID",
    value: "orgId",
    filterType: "string",
  },
  {
    headerText: "Organization Name",
    value: "orgName",
    filterType: "string",
  },
  {
    headerText: "Time Created",
    value: "timeCreated",
    filterType: "date",
  },
  {
    headerText: "Status",
    value: "status",
    filterType: "string",
  },
];

const { filters, headerColumns: baseHeaderColumns } = generateHeadersAndFilters(cloudZeroItemDescriptors);
const headerColumns = [...baseHeaderColumns] as const;

export { filters, headerColumns };
